<div class="thank-you-container">
  <div class="thank-you-card">
    <!-- Success Icon with Animation -->
    <div class="success-animation">
      <div class="success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      </div>
    </div>

    <!-- Thank You Title -->
    <h1 class="thank-you-title">Thank You!</h1>

    <!-- Message Content -->
    <div class="message-content">
      <p class="message-text">
        Thank you for submitting all the information.
      </p>
      <p class="message-text">
        Our team will review the necessary details, and within a few minutes you will receive a notification via email. You will then have the option to proceed with the payment, after which you will receive your policy documents instantly. Thank you.
      </p>
    </div>

    <!-- Go to Home Button -->
    <button class="home-button" (click)="goToHome()">
      <svg class="home-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
      </svg>
      Go to Home
    </button>
  </div>
</div>
